import { defineComponent, ref, openBlock, createElementBlock, Fragment, createElementVNode, normalizeClass, createBlock, unref, toDisplayString } from "vue";
import { IconPlayStroke, IconPauseStroke } from "@rei/cedar";
const _hoisted_1 = {
  class: "coop-img-asset__container"
};
const _hoisted_2 = ["srcset"];
const _hoisted_3 = ["src"];
const _hoisted_4 = ["srcset"];
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "pdp-sr-only"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "CoopImgAsset",
  props: {
    assets: {},
    showXlBreakpoint: {
      type: Boolean
    }
  },
  emits: ["metricsClick"],
  setup(__props, {
    emit: __emit
  }) {
    const isPaused = ref(false);
    const emit = __emit;
    function pauseGifs() {
      emit("metricsClick", {
        linkName: "gif_interaction"
      });
      isPaused.value = !isPaused.value;
    }
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock(Fragment, null, [createElementVNode("section", _hoisted_1, [createElementVNode("picture", null, [createElementVNode("source", {
        srcset: _ctx.assets.static.upper,
        media: "(prefers-reduced-motion: reduce)"
      }, null, 8, _hoisted_2), createElementVNode("img", {
        class: "coop-img-asset__img",
        src: isPaused.value ? _ctx.assets.static.upper : _ctx.assets.gif.upper,
        alt: "Rei Coop brand gif",
        loading: "lazy"
      }, null, 8, _hoisted_3)]), createElementVNode("picture", null, [createElementVNode("source", {
        srcset: _ctx.assets.static.lower,
        media: "(prefers-reduced-motion: reduce)"
      }, null, 8, _hoisted_4), createElementVNode("img", {
        class: "coop-img-asset__img coop-img-asset__img--secondary",
        src: isPaused.value ? _ctx.assets.static.lower : _ctx.assets.gif.lower,
        alt: "REI Coop brand tent with a user inside wearing a REI Coop brand sweater",
        loading: "lazy"
      }, null, 8, _hoisted_5)])]), createElementVNode("button", {
        class: normalizeClass(["coop-img-asset__pause-button", _ctx.showXlBreakpoint && "coop-img-asset__pause-button--xl"]),
        onClick: pauseGifs
      }, [isPaused.value ? (openBlock(), createBlock(unref(IconPlayStroke), {
        key: 0
      })) : (openBlock(), createBlock(unref(IconPauseStroke), {
        key: 1
      })), createElementVNode("span", _hoisted_6, toDisplayString(isPaused.value ? "Play" : "Pause") + " Gifs", 1)], 2)], 64);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=CoopImgAsset2.mjs.map
